// extracted by mini-css-extract-plugin
export default {"root":"IconMap_root__59EHm"};